<template>
  <div>
    <div class="card p-2">
      <div>
        <h3 class="mb-0">
          เพิ่มแบนเนอร์
        </h3>
      </div>

      <div class="row mt-1">
        <div class="col-md-6">
          <validation-observer ref="simpleRules">
            <b-form>
              <b-row>
                <b-col md="12">
                  <b-form-group label="หัวข้อ (ไม่บังคับ)">
                    <b-form-input
                      v-model="title"
                      placeholder="เช่น โปรโมชั่นพิเศษ"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group>
                    <label>ลิ้งรูป <span class="text-danger">*</span></label>
                    <validation-provider
                      #default="{ errors }"
                      name="ลิ้งรูป"
                      rules="required"
                    >
                      <b-form-input
                        v-model="img_url"
                        :state="errors.length > 0 ? false : null"
                        placeholder="https://..."
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <img
                    v-if="img_url"
                    :src="img_url"
                    class="img-fluid rounded border"
                    style="max-width: 100%; max-height: 200px; object-fit: contain"
                    @error="imgError = true"
                  >
                  <small v-if="imgError" class="text-danger">โหลดรูปไม่ได้ กรุณาตรวจสอบ URL</small>
                </b-col>

                <b-col md="12">
                  <b-form-group label="ลิงก์เมื่อคลิก (ไม่บังคับ)">
                    <b-form-input
                      v-model="link_url"
                      placeholder="https://..."
                    />
                  </b-form-group>
                </b-col>

                <b-col md="12">
                  <b-form-group label="ลำดับการแสดง (ตัวเลขน้อยแสดงก่อน)">
                    <b-form-input
                      v-model.number="order"
                      type="number"
                      min="0"
                      placeholder="0"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </div>

      <div class="col-md-12 mt-2">
        <b-button
          variant="primary"
          class="mr-1"
          @click.prevent="validationForm"
        >
          บันทึกข้อมูล
        </b-button>
        <b-button
          variant="outline-secondary"
          :to="{ name: 'banner' }"
        >
          ยกเลิก
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'CreateBanner',
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      required,
      title: '',
      img_url: '',
      link_url: '',
      order: 0,
      imgError: false,
    }
  },
  watch: {
    img_url() {
      this.imgError = false
    },
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          const obj = {
            title: this.title,
            img_url: this.img_url,
            link_url: this.link_url,
            order: this.order,
          }
          this.$http
            .post('banner/store', obj)
            .then(() => {
              this.Success('บันทึกข้อมูลสำเร็จ')
              this.$router.push('/Banner')
            })
            .catch(() => {
              this.SwalError('บันทึกไม่สำเร็จ')
            })
        }
      })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>
